import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={49}
    height={65}
    viewBox="0 0 49 65"
    fill="none"
    {...props}
  >
    <path
      stroke="#D9D9D9"
      fill="#FFFFFF"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M41.934 1.716 2.649 29.323c-2.199 1.546-2.199 4.824 0 6.37L41.934 63.3C44.477 65.086 48 63.247 48 60.13V4.886c0-3.145-3.497-4.984-6.066-3.171Z"
    />
  </svg>
)
export default SvgComponent
